<template>
  <RevCard
    class="w-4/5 max-w-fit self-start whitespace-pre-line px-16 py-12 md:w-3/5"
  >
    <slot />
  </RevCard>
</template>

<script lang="ts" setup>
import { RevCard } from '@ds/components/Card'
</script>
